<template>
	<div class="leaflet-map">
		<div v-if="!isNodata" :id="`map-${index}`" class="leaflet-map__view"></div>
		<div v-else class="leaflet-map__error">
			<p>{{ errorMessage }}</p>
		</div>
	</div>
</template>

<script>
import L from 'leaflet'

export default {
	name: 'LeafletMap',
	props: {
		coordinate: {
			type: Array,
			required: true
		},
		index: {
			type: Number,
			required: true
		},
		errorMessage: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			isNodata: false
		}
	},
	mounted () {
		if (this.errorMessage === '') {
			this.initMap()
		} else {
			this.isNodata = true
		}
	},
	methods: {
		initMap () {
			const bounds = L.latLngBounds(this.coordinate)
			const map = L.map(`map-${this.index}`, {
				zoomControl: false,
				touchZoom: true,
				doubleClickZoom: false,
				tap: false,
				boxZoom: false,
				keyboard: false
			}).fitBounds(bounds)
			// NOTE: zoomの最大値・最小値を設定した場合、散歩距離が短い場合に地図が表示されないためコメントアウト
			// const threshold = 2
			// const maxZoom = map.getBoundsZoom(bounds, false) + threshold
			// const minZoom = maxZoom - threshold

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
				// maxZoom: maxZoom,
				// minZoom: minZoom
			}).addTo(map)

			L.polyline(this.coordinate).addTo(map)

			this.$nextTick(() => {
				const matches = document.querySelectorAll('a')
				for (let i = 0, len = matches.length; i < len; i++) {
					matches[i].setAttribute('target', '_blank')
					matches[i].setAttribute('rel', 'noopener noreferrer')
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";
@import "../../assets/css/leaflet.css";

// NOTE: デザインシステム外のため他での利用禁止
$color-error-text: #666;

.leaflet-map {
	position: relative;
	width: 100%;
	height: 176px;
	overflow: hidden;

	.leaflet-map__view {
		position: static !important;
		width: 100%;
		height: 100%;
	}

	.leaflet-map__error {
		position: relative;
		width: 100%;
		height: 100%;
		font-family: $lp-family-primary;
		background-color: $background-list;

		p {
			position: absolute;
			width: 100%;
			margin: 0;
			padding: 0 $spacing-10;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			box-sizing: border-box;
			font-size: $font-size-14;
			text-align: center;
			color: $color-error-text;
		}
	}

	.leaflet-container { font-size: $font-size-10;}
}
</style>
